import getGameProfiles from '@api/getGameProfiles';
import getExternalGameProfiles from '@api/getExternalGameProfiles';
import updateGameProfile from '@api/updateGameProfile';
import { useMutation, useQuery } from 'react-query';
const useGameProfiles = ({ ugrId, onMutationSuccess, enabled = true }) => {
    const gameProfiles = useQuery(['gameProfiles', ugrId], () => {
        if (!ugrId) {
            throw new Error('User game region ID is required');
        }
        return getExternalGameProfiles(ugrId);
    }, {
        enabled: enabled && !!ugrId,
        staleTime: Infinity, // Profiles are unlikely to change often, so we can cache them indefinitely
    });
    const gameProfile = useQuery(['gameProfile', ugrId], () => {
        if (!ugrId) {
            throw new Error('User game region ID is required');
        }
        return getGameProfiles(ugrId);
    }, {
        enabled: enabled && !!ugrId,
        staleTime: Infinity, // Profiles are unlikely to change often, so we can cache them indefinitely
    });
    const mutateGameProfile = useMutation((newProfile) => updateGameProfile(newProfile.ugrId, newProfile.profileData), {
        onSuccess: () => {
            onMutationSuccess === null || onMutationSuccess === void 0 ? void 0 : onMutationSuccess();
        },
    });
    return {
        gameProfiles: gameProfiles.data,
        gameProfile: gameProfile.data,
        updateGameProfile: mutateGameProfile.mutate,
        isLoadingGameProfiles: gameProfiles.isLoading,
        isLoadingGameProfile: gameProfile.isLoading,
        isMutating: mutateGameProfile.isLoading,
        isError: gameProfiles.isError,
        error: gameProfiles.error,
        refetch: gameProfiles.refetch,
    };
};
export default useGameProfiles;
